<template>
  <section class="about__area pt-90 pb-150">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-12">
          <div class="about__thumb-wrapper">
            <div class="about__thumb">
              <img style="width:560px; cursor: pointer; object-fit: cover; border:1px solid rgba(128,128,128,0.25)" src="@/assets/img/about/boss1.jpg" alt="">
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-12">
          <div class="about__content pl-10 pr-10 pt-25">
            <div class="section__title-wrapper mb-25">
              <h2 class="section__title" style="font-size: 30px">{{$t('about.faoliyat')}} <span class="yellow-bg-sm">{{$t('about.faoliyat1')}}<img src="../../assets/img/shape/yellow-bg-2.png" alt=""></span> {{$t('about.faoliyat2')}}.</h2>
            </div>
            <div class="about__list mb-35"><h4>{{$t('about.faoliyat3')}}.</h4></div>
          </div>
        </div>
        <div class="col-12 mt-20">
          <div class="about__content pl-10 pr-10 pt-25">
            <div class="about__list mb-35">
              <h5>{{$t('about.faoliyat4')}}</h5>
              <ul class="pl-25">
                <li><i class="icon_check"></i>{{$t('about.faoliyat5')}}</li>
                <li><i class="icon_check"></i>{{$t('about.faoliyat6')}}</li>
                <li><i class="icon_check"></i>{{$t('about.faoliyat7')}}</li>
                <li><i class="icon_check"></i>{{$t('about.faoliyat8')}}</li>
                <li><i class="icon_check"></i>{{$t('about.faoliyat9')}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name:'AboutArea'
};
</script>
